import { AxiosResponse } from 'axios';
import * as DataTranslator from './../controllers/DataTranslator';
import api from '__application-api__';

export default async (data: DataTranslator.Request.MapLanguageInstance.Create.IData): Promise<AxiosResponse> => {
	return await api.EDITOR.mapCreate({ data });
}
